import React, { useState, useEffect, useCallback } from 'react'
import { Heading, Table, Button, Dialog, toaster, Checkbox } from 'evergreen-ui'
import RoundBtn from '../../Components/RoundBtn'
import InviteForm from '../Employee/InviteForm'
import { connect } from 'react-redux'
import { setLoading, unsetLoading } from '../../Redux/reducers/loading';
import EditForm from '../../Components/EditForm'
import axios from '../../Utils/axios';
const Operator = ({
  dispatch, loading
}) => {
  const [openModal, setModalForm] = useState(false)
  const [edit, setEdit] = useState(null)
  const [operators, setOperators] = useState([])
  const [showInactives, setShowInactives] = useState(true)

  const getOperators = useCallback(async() => {
    dispatch(setLoading())
    try {
      const { data } = await axios.get(`/company/operators`)
      setOperators(data.operators)
    }
    catch (error) {
      toaster.danger('Falha ao buscar dados')
    }
    finally {
      dispatch(unsetLoading())
    }
  }, [dispatch])

  useEffect(() => {
    getOperators()
  }, [getOperators])

  const save = async (user) => {
    try {
      await axios.put(`/company/operators/${user.__id__}`, {
        name: user.name,
        active: user.active
      })

      let operatorsList = operators.filter(operator => operator.__id__ !== user.__id__)
      setOperators([
        ...operatorsList,
        user
      ])
      toaster.success('Operador alterado com sucesso.')
      setEdit(null)
    }
    catch (error) {
      if (error.response) {
        toaster.danger(error.response.data.error.message)
      }
      else {
        toaster.danger('Falha na comunicação com o servidor')
      }
    }
  }

  async function saveInvite(payload) {
    dispatch(setLoading())
    try {
      const { status } = await axios.post(`/company/operators`, payload)

      if (status === 200) {
        await getOperators()
        toaster.success('Convite enviado ao operador')
        setModalForm(false)
      }
    } catch (error) {
      if (error.response && error.response.status === 500) {
        return toaster.danger('Falha ao enviar o convite')
      }

      return toaster.danger(error.response.data.error.message)
    }
    finally {
      dispatch(unsetLoading())
    }
  }

  async function remove({ __id__ }) {

    try {
      await axios.delete(`/company/operators/${__id__}`)
      setOperators(operators.filter(oper => oper.__id__ !== __id__))
    }
    catch (error) {
      toaster.danger(error.response.data.error.message)
    }
  }

  return (
    <div>
      <Heading size={600}>
        Operador
      </Heading>

      <Checkbox label="Mostrar Inativos"
        checked={showInactives}
        onChange={({ target }) => setShowInactives(target.checked)}
      />

      <Table style={{ marginTop: 15 }}>
        <Table.Head>
          <Table.TextHeaderCell>
            Nome
          </Table.TextHeaderCell>
          <Table.TextHeaderCell>
            E-mail
          </Table.TextHeaderCell>
          <Table.TextHeaderCell>
            Status
          </Table.TextHeaderCell>
          <Table.TextHeaderCell width={220} flex="none">
            Ações
          </Table.TextHeaderCell>
        </Table.Head>
        <Table.VirtualBody height={600}>
          {operators.filter(operator => showInactives ? operator : operator.active).sort((a, b) => b.__id__ < a.__id__).map(operator => (
            <Table.Row key={operator.__id__}>
              <Table.TextCell>{operator.name}</Table.TextCell>
              <Table.TextCell>{operator.email}</Table.TextCell>
              <Table.TextCell>{operator.active ? 'Ativo' : 'Inativo'}</Table.TextCell>
              <Table.TextCell width={320} flex='none' >
                <Button
                  iconBefore='edit'
                  marginRight={20}
                  onClick={() => setEdit(operator)}
                > Editar </Button>
                <Button
                  iconBefore='edit'
                  marginRight={20}
                  onClick={() => remove(operator)}
                > Remover </Button>
              </Table.TextCell>
            </Table.Row>
          ))}
        </Table.VirtualBody>

      </Table >
      <RoundBtn disabled={loading} action={() => setModalForm(true)} />

      { edit && (
        <Dialog
          isShown={!!edit}
          title="Altere o usuário"
          onCloseComplete={() => setEdit(null)}
          hasFooter={false}
          shouldCloseOnOverlayClick={false}
        >
          <EditForm user={edit} edit={(result) => save(result) } showEdit={false} />
        </Dialog>
        )
      }
      <Dialog
        isShown={openModal}
        shouldCloseOnOverlayClick={false}
        title="Faça o convite"
        onCloseComplete={() => setModalForm(false)}
        hasFooter={false}
      >
        <InviteForm save={(payload) => saveInvite(payload)} close={() => setModalForm(false)} />
      </Dialog>
    </div>
  )
}


const mapStateToProps = ({ auth, loading }) => ({
  company: auth.account.company, loading: loading.isLoading
})
export default connect(mapStateToProps)(Operator)